module.exports = __webpack_public_path__ + "static/media/Statua_036.c1edd3b0.jpg";